<template>
<div>
    <div
        class="modal trader-info acc-rej"
        id="trader-info"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        
      >
        <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 1440px;">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Offer accept or reject</h5>
               <div class="float-right">
                    <button type="button" @click="getOffer()" class="btn btn-sm">
                        <span class="fas fa-sync-alt" aria-hidden="true"></span> Refresh
                    </button>
                    <button type="button" class="close"  @click="closePopup()">
                        <span aria-hidden="true">&times;</span>
                    </button>
               </div>
              
            </div>
            <div class="modal-body">
                <div class="table-responsive">
                <table class="table align-items-center table-flush table-hover bidtbl">
                    <thead class="thead-light psticky">
                    <tr>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >Cusip</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >Limit <br> Order</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >QTY / <br> Min Qty</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >ECN</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >Offer <br> Price/Yield</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >Offer Ordered <br> Price</th>
                        <th 
                        scope="col" 
                        class=" text-center"
                        >Ordered <br> Quantity</th>
                        <th 
                        scope="col" 
                        class=" text-center"
                        >Avg <br> Cost</th>
                        <th 
                        scope="col" 
                        class=" text-center"
                        >Spread</th>
                        <th 
                        scope="col" 
                        class=" text-center text-danger"
                        >Source</th>
                        <th 
                        scope="col" 
                        class=" text-center"
                        >Trader</th>
                        <th 
                        scope="col" 
                        class=" text-center"
                        >Settlement Date</th>
                        <th 
                        scope="col" 
                        class=" text-center"
                        >Action</th>
                    </tr>
                    </thead>  
                    <tbody class="">
                        <tr >
                            <td v-if="offers.length == 0 && !loader"><p class="nodata">No data available</p>
                            </td>
                            <td v-if="loader">
                                <div class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                            </td>
                        </tr>
                        <tr v-for="offer in offers" :key="offer.id" v-bind:class="{'row-highlight-red': offer.isLimitOrder }">
                            <td  
                            v-bind:class="{ 'cusips cusip-orange mt-4': offer.hasMultipleOrders }" 
                            class="text-center ">
                            <div v-if="offer.hasMultipleOrders"   data-toggle="tooltip" 
                            data-placement="left"  
                            v-bind:title='"This offer has multiple orders."'  >{{offer.cusip}} </div>
                            <div v-if="!offer.hasMultipleOrders">{{offer.cusip}} </div>
                            <span v-if="offer.offerAlertType == 'ORDER_CANCELLED'" class="cusips cusip-orange">Canceled</span></td>
                            <td class="text-center">{{offer.isLimitOrder ? 'YES' : 'NO'}}</td>
                            <td class="text-center">{{offer.quantity}} / {{offer.minQuantity}}</td>
                            <td class="text-center">{{offer.ecn}}</td>
                            <td class="text-center">{{offer.offerEcnPrice}}</td>
                            <td class="text-center">{{offer.filledAmount}}</td>
                            <td class="text-center">{{offer.filledQuantity}}</td>
                            <td class="text-center">{{offer.avgCost.toFixed(3)}}</td>
                            <td class="text-center">{{(offer.filledAmount - offer.avgCost).toFixed(2)}}</td>
                            <td class="text-center text-danger">
                            <span>{{offer.createSource.toString().toLocaleUpperCase().replace("_", " ")}}</span>
                            <div class="mt-1 d-flex" style="flex-direction: column;">
                                <span v-for="(source, index) in offer.arbsRankedSources" :key="index" class="badge badge-pill badge-primary mb-1"> 
                                    {{ source.ecn }} : {{ source.price }} ({{ source.qty }})
                                </span>
                            </div>
                            </td>
                            <td class="text-center">{{offer.traderFirstName}} {{offer.traderLastName }} <br>
                                 <span v-if="offer.isAway" class="text-danger">AWAY</span>
                            </td>
                            <td class="text-center">
                                <span>{{offer.settlDateEcn ? moment(offer.settlDateEcn).format("MM/DD/YYYY"): ''}}</span>
                            </td>
                            <td class="text-center"> 
                                <button type="button" @click="holdings = offer.holding" class="btn ibtn btn-outline-primary" title="Holdings" data-toggle="modal" data-target="#custDls" ><i class="far fa-user"></i></button>
                                <button v-if="offer.offerAlertType == 'ORDER_RECEIVED'" type="button" @click="setofferAction('accept',offer)" class="btn btn-success">Accept</button>
                                <button v-if="offer.offerAlertType == 'ORDER_RECEIVED'" type="button" @click="setofferAction('reject',offer)" class="btn btn-danger">Reject</button>
                                <!-- <span   v-if="offer.offerAlertType == 'ORDER_CANCELLED'">Cancelled</span> -->
                                <button v-if="offer.offerAlertType == 'ORDER_CANCELLED'" type="button" @click="clearOffer('reject',offer)" class="btn btn-warning">Clear</button>
                            
                                
                            </td>
                        </tr>                    
                    </tbody>
                </table>
                </div>
            </div>
          </div>
        </div>
    </div>
    <div class="modal" id="custDls" tabindex="-1" role="dialog" aria-labelledby="custDls" aria-hidden="true"> 
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
               <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Holdings</h5>
                        <button type="button" class="close"  data-dismiss='modal'><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="modal-body">
                        <table class="table align-items-center table-flush table-hover bidtbl">
                            <thead class="thead-light psticky">
                                <th scope="col" class="text-left">Account</th>
                                <th scope="col" class="text-left"> Bought</th>
                                <th scope="col" class="text-right">Cost</th>
                            </thead>
                            <tbody>
                                <tr v-for="holding in holdings" :key="holding.nameWithAccount">
                                    <td class="text-left text-primary">{{holding.nameWithAccount}}</td>
                                    <td class="text-left">{{moment(holding.boughtDate).format("MM/DD/YYYY")}}</td>
                                    <td class="text-right"><span class="border border-success rounded px-3 py-1 text-success">{{holding.cost | currency}}</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>  
                </div>
            </div> 
        </div>
</div>      
</template>
<script>
import authService from "@/authService";
import config from "@/config";
export default {
    name: 'OfferAcceptPopUp',
    data() {
        return {
            cognitoSub : null,
            offers:[],
            loader : false,
            holdings : [],
            retryCounter : 0,
            broadcastChannel : null,
           

        };
    },
    methods : {
    closePopup(){
       this.broadcastChannel.postMessage({ message: 'close' });
       this.$emit('close');
    }, 
    clearOffer(action,offer){
        this.loader = true;
            const auth = {
                headers: {'org-token' : authService.getOrgToken() }
            };
            this.$http
            .put(
                config.baseUrlBidSide + '/offer/update-order-status',
                    {
                    "cognitoSub" : this.cognitoSub,
                    "offerId": offer.offerId+"",
                    "offerAlertId": offer.id+"",
                    "status": "REJECTED"
                    },
                auth
            )
            .then(() => {
                this.loader = false;
                // get index of object with id
                var removeIndex = this.offers.map(function(item) { return item.id; }).indexOf(offer.id);
                // remove object
                this.offers.splice(removeIndex, 1);
                if(this.offers.length == 0){
                    this.closePopup();
                }
                this.broadcastChannel.postMessage({ message: 'action' });

            })
            .catch(() => {
                this.loader = false;
            });

    },    
    setofferAction(action,offer){
        var limitOrderMsg = "";
        if(action == 'reject' && !offer.isLimitOrder){
            limitOrderMsg = "You are rejecting a non-limit order. This offer will be suspended.";
        }
        var message = limitOrderMsg+" Are you sure you want to "+action+" this offer?";
        this.$confirm(message,"","question",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
            this.loader = true;
            const auth = {
                headers: {'org-token' : authService.getOrgToken() }
            };
            this.$http
            .put(
                config.baseUrlBidSide + '/offer/update-order-status',
                    {
                    "cognitoSub" : this.cognitoSub,
                    "offerId": offer.offerId+"",
                    "offerAlertId": offer.id+"",
                    "status": action == 'accept' ? "ACCEPTED" : "REJECTED",
                    "acceptArbsOrders": false,
                    "arbsRankedSources": offer.arbsRankedSources
                    },
                auth
            )
            .then((response) => {
                this.loader = false;
                if(response.data.arbsActionBlocked){
                    this.showArbsConfirmaion(response.data.message, offer);
                }else{
                     // get index of object with id
                    var removeIndex = this.offers.map(function(item) { return item.id; }).indexOf(offer.id);
                    // remove object
                    this.offers.splice(removeIndex, 1);
                    if(this.offers.length == 0){
                        this.closePopup();
                    }
                    this.broadcastChannel.postMessage({ message: 'action' });

                }

               
            })
            .catch(() => {
                this.loader = false;
            });
        });
        
    },
    showArbsConfirmaion(message,offer){
        this.$confirm(message,"","question",{confirmButtonText:"Accept anyway",cancelButtonText : "Cancel"}).then(() => {
            const auth = {
                headers: {'org-token' : authService.getOrgToken() }
            };
            this.$http
            .put(
                config.baseUrlBidSide + '/offer/update-order-status',
                    {
                    "cognitoSub" : this.cognitoSub,
                    "offerId": offer.offerId+"",
                    "offerAlertId": offer.id+"",
                    "status": "ACCEPTED",
                    "acceptArbsOrders": true,
                    "arbsRankedSources": offer.arbsRankedSources
                    },
                auth
            ).then(() => {
                 // get index of object with id
                    var removeIndex = this.offers.map(function(item) { return item.id; }).indexOf(offer.id);
                    // remove object
                    this.offers.splice(removeIndex, 1);
                    if(this.offers.length == 0){
                        this.closePopup();
                    }
                    this.broadcastChannel.postMessage({ message: 'action' });

            })

        });
    },  
    getOffer(){
        this.loader = true;
        this.retryCounter = this.retryCounter+1;
         const auth = {
         headers: {'org-token' : authService.getOrgToken() }
         };
         this.$http
         .get(
            config.baseUrlBidSide + '/offer-alerts/list?status=UNREAD&cognitoSub='+this.cognitoSub,
               auth
         )
         .then(result => {
            //If result is empty retry api call
            if(result.data.length === 0 && this.retryCounter < 3){
                setTimeout(() => { 
                    this.getOffer(); 
                    return false;
                },1000)
                
            } 
            result.data.forEach(element => {
                if(element.ecn == 'IBP'){
                element.ecn = "BondPoint"
                }
                if(element.ecn == 'TWD'){
                element.ecn = "TradeWeb"
                }
            });
            this.offers = result.data;
            this.offers.forEach(offer => {
                if(offer.filledAmount != offer.offerEcnPrice){
                    offer.isLimitOrder = true
                }
                if(offer.quantity < offer.filledQuantity){
                    offer.isLimitOrder = true
                }
                if(offer.quantity > offer.filledQuantity && (offer.quantity - offer.filledQuantity) <= 5 ){
                    offer.isLimitOrder = true
                }
                if(offer.minQuantity > offer.filledQuantity){
                    offer.isLimitOrder = true
                }
                if(offer.increment != null && Number(offer.increment) !== 0 && offer.filledQuantity % offer.increment !== 0){
                    offer.isLimitOrder = true
                }
                if(Array.isArray(offer.createSource)){
                    offer.createSource.forEach((source,i) => {
                        if(!source.toLowerCase().includes('arbs')) offer.createSource[i] = "IMS"
                    });
                }
                //offer.createSource = offer.createSource.includes('arbs') ? offer.createSource.replace("_"," ").toUpperCase() : "IMS";

            });

            this.loader = false;
         })
         .catch(() => {
            this.loader = false;
        });
    },
    handleMessage(event) {
      // Handle incoming messages from other tabs
      if(event.data.message === "close"){
        this.$emit('close');
      }
      if(event.data.message === "action"){
        this.getOffer();
      }
    },
  },
  created(){ 
    this.cognitoSub = authService.getUser().cognitoSub;
    this.getOffer();
  },
  mounted(){
    this.$root.$on("orderrefresh", () => {
        console.log("Refreshing list....");
        this.retryCounter = 0;
        this.getOffer();
    });
    // Create a Broadcast Channel with the same channel name
    this.broadcastChannel = new BroadcastChannel('order-ims');
    this.broadcastChannel.addEventListener('message', this.handleMessage);

  },
  beforeDestroy() {
    this.$root.$off("orderrefresh");
    this.broadcastChannel.close();

  }
};
</script>